import type { ArchivedMetrics, MetricType } from '@splunk/olly-imm';

interface Query {
    property: string;
    propertyValue: string | string[];
    NOT: boolean;
}

type Plot = {
    seriesData: { metric: string };
    queryItems: Query[];
};

type SFUIModel = {
    allPlots: Plot[];
};

export function mapArchivedMetricsToRuleset(
    archivedMetrics: ArchivedMetrics,
    model: SFUIModel
): MetricType[] {
    const metrics = [];
    for (const plot of model.allPlots) {
        if (plot.seriesData.metric && plot.seriesData.metric in archivedMetrics) {
            for (const metric of archivedMetrics[plot.seriesData.metric]) {
                metrics.push({
                    rulesetId: metric.rulesetId,
                    metricName: metric.metricName,
                    filters: plot.queryItems.map(({ property, propertyValue, NOT }) => ({
                        property,
                        propertyValue: Array.isArray(propertyValue)
                            ? propertyValue
                            : [propertyValue],
                        NOT,
                    })),
                });
            }
        }
    }
    return metrics;
}
